import { h } from 'preact';

import Grid from '@mui/material/Grid';

import LazyLcpUrlIssueDetail from './lazyUrlIssueDetail.jsx';

export default function LazyLcpUrlIssueDetails(_props) {
  return (
    <Grid container justifyContent="center">
      <Grid item xs={12}>
        <LazyLcpUrlIssueDetail />
      </Grid>
    </Grid>
  );
}
